import React from 'react';
import SettingsLayout from '../../components/SettingsLayout';
import { PlaceholderCard } from '../../components/PlaceholderCard';
import { Users } from 'lucide-react';

const TeamPage = () => (
  <SettingsLayout title="Team" description="Invite collaborators, assign roles, and manage seats.">
    <PlaceholderCard
      icon={Users}
      title="Team members unlock on Basic plan"
      description="Invite up to 3 collaborators on Basic, unlimited on Pro. Roles: Admin, Editor, Viewer. Available at public launch."
      badge="Basic plan"
      primaryLabel="See plans"
      primaryTo="/pricing"
      testIdBase="team"
      waitlistFeature="team_members"
    />
  </SettingsLayout>
);

export default TeamPage;
